import { Alert, Box, Button, Flex } from '@chakra-ui/react';
import { MdCloudUpload, MdWarning } from 'react-icons/md';
import { useCallback, useState } from 'react';

import { Txt } from '@app/components/common';
import { Upload } from '@app/components/common/upload';
import { useAlert, useApi } from '@app/hooks';
import { TemplateDownload } from '@app/pages/equipments/imports/components/template-download';
import { Confirm } from '@app/pages/equipments/imports/components/confirm';

export const OutletRouteNumberLinkDeleteImport = () => {
  const api = useApi();
  const { error, success } = useAlert();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<File>();

  const onFileChange = useCallback((_: string, file: File) => {
    setFile(file);
  }, []);

  const onImportClick = useCallback(() => {
    if (!file) {
      error('Файл не выбран');
      return;
    }
    setOpen(true);
  }, [error, file]);

  const onImport = useCallback(async () => {
    setLoading(true);
    const content: string = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.readAsDataURL(file);
    });

    const response = await api.imports.uploadOutletRouteNumberLinkDelete({
      filename: file.name,
      content,
    });
    if (response.code === 200) {
      success(response.message);
    }
    setLoading(false);
  }, [api.imports, file, success]);

  const onConfirm = useCallback(() => {
    setOpen(false);
    onImport();
  }, [onImport]);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  return <>
    <Flex flexDirection='column' gap={4} p={{ base: 2, md: 0 }}>
      <Flex gap={4} alignItems='flex-start' justifyContent='space-evenly' flexDirection={{ base: 'column', md: 'row' }}>
        <Box flex={1}>
          <Alert status='info' flexDirection='column' alignItems='flex-start' minH='100%'>
            <Box>
              <Txt>Импорт удаления связей ТТ с маршрутами.</Txt>
            </Box>
            <Box mt={2}>
              <Txt>Файл должен содержать в себе колонки согласно шаблона</Txt>
            </Box>
          </Alert>
          <Box mt={2}>
            <TemplateDownload label="Получить шаблон" method={api.imports.getOutletRouteNumberLinkTemplate} />
          </Box>
        </Box>
      </Flex>
      <Box minH={200} display='flex' flexDirection='column'>
        <Upload
          onChange={onFileChange}
          label="Выберите Excel файл со связями ТТ с маршрутами"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        />
      </Box>
      <Flex gap={4} alignItems='flex-start'>
        <Alert status='warning' display='flex' alignItems='flex-start'>
          <Box mt={2} mr={3}>
            <MdWarning size={24} />
          </Box>
          Пожалуйста, обратите внимание, что процесс импорта данных происходит автоматически. Убедитесь, что данные, которые вы импортируете, действительно содержат необходимые изменения, так как после импорта их будет невозможно откатить и вернуть в исходное состояние.
        </Alert>
        <Box>
          <Button
            isLoading={loading}
            onClick={onImportClick}
            variant='solid'
            colorScheme='brand'
            size='md'
            iconSpacing={2}
            leftIcon={<MdCloudUpload size='24px' />}
            aria-label="добавить"
          >
            Загрузить
          </Button>
        </Box>
      </Flex>
    </Flex>
    <Confirm open={open} onClose={onClose} onConfirm={onConfirm} />
  </>;
};
